export default {"src":"/_next/static/media/google-play-badge.6a9453cb.svg","height":48,"width":157};